import React, { useRef } from 'react';
import { SIZE_CLASSES } from './constants/avatarConstants';
import { getFrameType, getFrameClass } from './utils/frameUtils';
import { getAvatarGradient, getDisplayName } from './utils/avatarUtils';
import { useAvatarUrl } from './hooks/useAvatarUrl';
import { useAvatarAnimation } from './hooks/useAvatarAnimation';
import AvatarImage from './components/AvatarImage';
import AvatarInitial from './components/AvatarInitial';
import BinaryCode from './components/BinaryCode';
import AvatarTooltip from './components/AvatarTooltip';
import './UserAvatar.css';

const UserAvatar = ({
  user,
  size = 'medium',
  showTooltip = false,
  tooltipContent = null,
  className = '',
  onClick = null,
  withFrame = true,
  frameType = null
}) => {
  const avatarRef = useRef(null);
  const displayName = getDisplayName(user);
  const { avatarUrl, imageError, setImageError } = useAvatarUrl(user?.avatar);
  const avatarGradient = getAvatarGradient(user?.rating);
  const currentFrameType = getFrameType(user, frameType);
  const frameClass = getFrameClass(withFrame, frameType, user);
  const sizeClass = SIZE_CLASSES[size];

  useAvatarAnimation(withFrame, user, frameType, avatarRef);

  const handleImageError = () => {
    setImageError(true);
  };

  // Проверка на отсутствие user
  if (!user) {
    return (
      <div className={`user-avatar-component ${sizeClass} ${className}`}>
        <span className="avatar-initial">?</span>
      </div>
    );
  }

  const avatarContent = (
    <div
      ref={avatarRef}
      className={`user-avatar-component ${sizeClass} ${frameClass} ${className}`}
      style={{ background: avatarGradient }}
      onClick={onClick}
    >
      {avatarUrl && !imageError ? (
        <AvatarImage
          src={avatarUrl}
          alt={displayName}
          onError={handleImageError}
        />
      ) : (
        <AvatarInitial displayName={displayName} />
      )}
      {currentFrameType === 'librarian' && <BinaryCode />}
    </div>
  );

  if (showTooltip && tooltipContent) {
    return (
      <AvatarTooltip content={tooltipContent}>
        {avatarContent}
      </AvatarTooltip>
    );
  }

  return avatarContent;
};

export default UserAvatar;